var exports = {
  "p": "xe7b6e3d6--5abeb5--list",
};

module.exports = exports;
